// src/features/dashboard/services/teamKpiApi.ts

import api from '../../../api/apiService';
import { ENDPOINTS } from '../../../api/endpoints';

/**
 * =========================================
 * REQUEST
 * =========================================
 */
export type TeamKpiPayload = {
  ManagerEmployeeCode: string;
  fromDate: string;
  toDate: string;
};

/**
 * =========================================
 * RESPONSE
 * =========================================
 */
export type DashboardSummaryResponse = {
  teamMembers: number;
  avgDailyActiveHours: number;
  productivePercentage: number;
  below6HoursDays: number;
  leaveDays: number;
};

/**
 * =========================================
 * API
 * =========================================
 */
export const getTeamKpi = async (
  payload: TeamKpiPayload,
): Promise<DashboardSummaryResponse> => {

  const response =
    await api.post<DashboardSummaryResponse>(
      ENDPOINTS.TEAM_KPI,
      payload,
    );

  return response.data;
};